var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    { attrs: { small: true, "sticky-header": "" } },
    [
      _c(
        "b-thead",
        [
          _c(
            "b-tr",
            [
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "10%",
                  },
                },
                [_vm._v("Field")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "45%",
                  },
                },
                [_vm._v("Old")]
              ),
              _c(
                "b-th",
                {
                  staticStyle: {
                    "text-align": "left",
                    "vertical-align": "middle",
                    width: "45%",
                  },
                },
                [_vm._v("New")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-tbody",
        _vm._l(_vm.items.new, function (ds, index) {
          return _c(
            "b-tr",
            [
              _vm.arrayFields.indexOf(index) === -1
                ? [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c("b-td", [_vm._v(_vm._s(_vm.items.old[index]))]),
                    _c("b-td", [_vm._v(_vm._s(_vm.items.new[index]))]),
                  ]
                : index === "datasource"
                ? [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [_c("b-tr", [_c("b-th", [_vm._v("Name")])], 1)],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.old[index],
                                function (datasource, idx1) {
                                  return _c(
                                    "b-tr",
                                    [
                                      _c("b-td", [
                                        _vm._v(_vm._s(datasource.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [_c("b-tr", [_c("b-th", [_vm._v("Name")])], 1)],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.new[index],
                                function (datasource, idx1) {
                                  return _c(
                                    "b-tr",
                                    [
                                      _c("b-td", [
                                        _vm._v(_vm._s(datasource.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : index === "groups"
                ? [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [_c("b-tr", [_c("b-th", [_vm._v("Name")])], 1)],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.old[index],
                                function (group, idx1) {
                                  return _c(
                                    "b-tr",
                                    [_c("b-td", [_vm._v(_vm._s(group.name))])],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [_c("b-tr", [_c("b-th", [_vm._v("Name")])], 1)],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.new[index],
                                function (group, idx1) {
                                  return _c(
                                    "b-tr",
                                    [_c("b-td", [_vm._v(_vm._s(group.name))])],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : index === "project"
                ? [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [_c("b-tr", [_c("b-th", [_vm._v("Name")])], 1)],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.old[index],
                                function (project, idx1) {
                                  return _c(
                                    "b-tr",
                                    [
                                      _c("b-td", [
                                        _vm._v(_vm._s(project.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [_c("b-tr", [_c("b-th", [_vm._v("Name")])], 1)],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.new[index],
                                function (project, idx1) {
                                  return _c(
                                    "b-tr",
                                    [
                                      _c("b-td", [
                                        _vm._v(_vm._s(project.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : index === "workbook"
                ? [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [
                                _c(
                                  "b-tr",
                                  [
                                    _c("b-th", [_vm._v("Id")]),
                                    _c("b-th", [_vm._v("Name")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.old[index],
                                function (workbook, idx1) {
                                  return _c(
                                    "b-tr",
                                    [
                                      _c("b-td", [_vm._v(_vm._s(workbook.id))]),
                                      _c("b-td", [
                                        _vm._v(_vm._s(workbook.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-td",
                      { staticStyle: { "vertical-align": "top" } },
                      [
                        _c(
                          "b-table-simple",
                          { attrs: { small: true, "sticky-header": "" } },
                          [
                            _c(
                              "b-thead",
                              [
                                _c(
                                  "b-tr",
                                  [
                                    _c("b-th", [_vm._v("Id")]),
                                    _c("b-th", [_vm._v("Name")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-tbody",
                              _vm._l(
                                _vm.items.new[index],
                                function (workbook, idx1) {
                                  return _c(
                                    "b-tr",
                                    [
                                      _c("b-td", [_vm._v(_vm._s(workbook.id))]),
                                      _c("b-td", [
                                        _vm._v(_vm._s(workbook.name)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c("b-td", [_vm._v(_vm._s(_vm.items.old[index]))]),
                    _c("b-td", [_vm._v(_vm._s(_vm.items.new[index]))]),
                  ],
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }